import { create } from 'zustand'

const KEY = 'emag.selectedClientId'

interface ClientSelectionState {
  selectedClientId: number | null
  setSelectedClientId: (id: number | null) => void
}

export const useClientSelection = create<ClientSelectionState>((set) => ({
  selectedClientId: (() => {
    const v = typeof localStorage !== 'undefined' ? localStorage.getItem(KEY) : null
    return v ? Number(v) : null
  })(),
  setSelectedClientId: (id) => {
    if (typeof localStorage !== 'undefined') {
      if (id == null) localStorage.removeItem(KEY)
      else localStorage.setItem(KEY, String(id))
    }
    set({ selectedClientId: id })
  },
}))
